export default {
    lang: '中文/EN',
    navList: {
        page: '首页',
        about: '关于我们'
    }
}